import React from 'react';
import {
  PlayIcon,
  PauseIcon,
  StopIcon,
  MicrophoneIcon,
  ArrowDownTrayIcon,
  TrashIcon,
  DocumentDuplicateIcon,
  ArrowPathIcon,
  CheckCircleIcon,
  XCircleIcon,
  Cog6ToothIcon,
  ChartBarIcon,
  ClockIcon,
  AdjustmentsHorizontalIcon,
  MusicalNoteIcon,
  SpeakerWaveIcon,
  SpeakerXMarkIcon,
  DocumentTextIcon,
  BoltIcon,
} from '@heroicons/react/24/solid';

import {
  PlayIcon as PlayOutline,
  PauseIcon as PauseOutline,
  StopIcon as StopOutline,
  MicrophoneIcon as MicOutline,
} from '@heroicons/react/24/outline';

export const Icons = {
  // Solid variants
  play: PlayIcon,
  pause: PauseIcon,
  stop: StopIcon,
  microphone: MicrophoneIcon,
  download: ArrowDownTrayIcon,
  delete: TrashIcon,
  copy: DocumentDuplicateIcon,
  refresh: ArrowPathIcon,
  check: CheckCircleIcon,
  error: XCircleIcon,
  settings: Cog6ToothIcon,
  chart: ChartBarIcon,
  clock: ClockIcon,
  sliders: AdjustmentsHorizontalIcon,
  music: MusicalNoteIcon,
  volume: SpeakerWaveIcon,
  volumeMute: SpeakerXMarkIcon,
  document: DocumentTextIcon,
  bolt: BoltIcon,

  // Outline variants
  playOutline: PlayOutline,
  pauseOutline: PauseOutline,
  stopOutline: StopOutline,
  microphoneOutline: MicOutline,
};

/**
 * Reusable Icon component
 *
 * @param {string} name - Icon name from Icons object
 * @param {number} size - Icon size in pixels (default: 20)
 * @param {string} className - Additional CSS classes
 * @param {object} style - Inline styles
 */
export const Icon = ({ name, size = 20, className = '', style = {}, ...props }) => {
  const IconComponent = Icons[name];

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  return (
    <IconComponent
      className={`inline-block ${className}`}
      style={{ width: size, height: size, ...style }}
      {...props}
    />
  );
};

export default Icon;
